import { SelectableAnswerSlideItemType } from '@llx/common';
import { Dispatch, useEffect } from 'react';

type Args = {
  forceDeactivateGlowFeature: boolean;
  isAnswerConfirmed: boolean;
  voteItems: SelectableAnswerSlideItemType[];
  hasAtleastSelectedOneAnswer: boolean;
  glowingVoteItem: SelectableAnswerSlideItemType | undefined;
  setGlowingVoteItem: Dispatch<SelectableAnswerSlideItemType | undefined>;
};

export const answerGlowDuration = 2000;

export function useAnswerGlowingLogic({
  isAnswerConfirmed,
  forceDeactivateGlowFeature,
  hasAtleastSelectedOneAnswer,
  voteItems,
  glowingVoteItem,
  setGlowingVoteItem,
}: Args) {
  //NOTE: This is for the background glow of the answers when we haven't answered yet
  useEffect(() => {
    if (
      isAnswerConfirmed ||
      forceDeactivateGlowFeature ||
      hasAtleastSelectedOneAnswer ||
      voteItems.length <= 0
    )
      return;

    const interval = setInterval(() => {
      if (!glowingVoteItem) {
        setGlowingVoteItem(voteItems[0]);
        return;
      }
      const index = voteItems.indexOf(glowingVoteItem);
      setGlowingVoteItem(voteItems[(index + 1) % voteItems.length]);
    }, answerGlowDuration);

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [
    isAnswerConfirmed,
    forceDeactivateGlowFeature,
    voteItems,
    hasAtleastSelectedOneAnswer,
    glowingVoteItem,
  ]);
}
